import { render, staticRenderFns } from "./syarat-ketentuan.vue?vue&type=template&id=4e92b650&"
import script from "./syarat-ketentuan.vue?vue&type=script&lang=ts&"
export * from "./syarat-ketentuan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports